import React, { useState } from 'react';
import './Header.css';
import { useLanguage } from '../contexts/LanguageContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { currentLanguage, changeLanguage, t } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (e, target) => {
    e.preventDefault();
    closeMenu();
    
    // Smooth scroll to target
    const element = document.querySelector(target);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img src="/images/Group 1000003026.png" alt="PhiAI Logo" className="logo-image" />
        </div>
        
        {/* Desktop Navigation */}
        <nav className="nav desktop-nav">
          <a href="#problem" className="nav-link" onClick={(e) => handleNavClick(e, '#problem')}>{t('header.problem')}</a>
          <a href="#cozum" className="nav-link" onClick={(e) => handleNavClick(e, '#cozum')}>{t('header.solution')}</a>
          <a href="#design" className="nav-link" onClick={(e) => handleNavClick(e, '#design')}>{t('header.design')}</a>
          <a href="#technology" className="nav-link" onClick={(e) => handleNavClick(e, '#technology')}>{t('header.technology')}</a>
        </nav>

        {/* Language Selector */}
        <div className="language-selector">
          <button 
            className={`lang-btn ${currentLanguage === 'tr' ? 'active' : ''}`}
            onClick={() => changeLanguage('tr')}
          >
            TR
          </button>
          <span className="lang-separator">|</span>
          <button 
            className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`}
            onClick={() => changeLanguage('en')}
          >
            EN
          </button>
        </div>

        {/* Mobile Hamburger Button */}
        <button className="hamburger" onClick={toggleMenu} aria-label="Menu">
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
        </button>

        {/* Mobile Navigation Drawer */}
        <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <div className="mobile-nav-content">
            <a href="#problem" className="mobile-nav-link" onClick={(e) => handleNavClick(e, '#problem')}>
              {t('header.problem')}
            </a>
            <a href="#cozum" className="mobile-nav-link" onClick={(e) => handleNavClick(e, '#cozum')}>
              {t('header.solution')}
            </a>
            <a href="#design" className="mobile-nav-link" onClick={(e) => handleNavClick(e, '#design')}>
              {t('header.design')}
            </a>
            <a href="#technology" className="mobile-nav-link" onClick={(e) => handleNavClick(e, '#technology')}>
              {t('header.technology')}
            </a>
            
            {/* Mobile Language Selector */}
            <div className="mobile-language-selector">
              <button 
                className={`lang-btn ${currentLanguage === 'tr' ? 'active' : ''}`}
                onClick={() => changeLanguage('tr')}
              >
                TR
              </button>
              <span className="lang-separator">|</span>
              <button 
                className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`}
                onClick={() => changeLanguage('en')}
              >
                EN
              </button>
            </div>
          </div>
        </nav>

        {/* Overlay */}
        {isMenuOpen && <div className="mobile-nav-overlay" onClick={closeMenu}></div>}
      </div>
    </header>
  );
};

export default Header; 